import { inject, injectable } from "inversify";
import { ClientPortalWebNarratives } from "cpl-react-common/components/Enums/ClientPortalWebNarratives";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ClientPortalWebNarrativeModel, ICPLClientPortalWebNarrativesClient } from "./api/cplapi/CPLAPI";

export interface IClientPortalWebNarrativesService {
  getClientPortalWebNarrative(
    clientPortalWebNarrativeID: ClientPortalWebNarratives
  ): Promise<ClientPortalWebNarrativeModel>;
}

@injectable()
export class ClientPortalWebNarrativesService implements IClientPortalWebNarrativesService {
  @inject(SERVICE_TYPES.CPLClientPortalWebNarrativesClient)
  clientPortalWebNarrativesClient!: ICPLClientPortalWebNarrativesClient;

  getClientPortalWebNarrative(clientPortalWebNarrativeID: ClientPortalWebNarratives) {
    return this.clientPortalWebNarrativesClient.getClientPortalWebNarrative(clientPortalWebNarrativeID);
  }
}
